<template>
    <v-card>
        <v-card-title>
            Endre status: {{application ? application.name : '-'}}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="4">
                    <v-radio-group v-model="currentStatus" label="Statuser" class="ma-0">
                        <v-radio :label="status.name" :value="status" v-for="status in statuses" :key="status.type">
                            <template v-slot:label>
                                <div>{{status.name}}</div>
                                <v-icon v-if="status == originalStatus" color="success" small>mdi-star-circle</v-icon>
                            </template>
                        </v-radio>
                    </v-radio-group>

                    <div class="d-flex">
                        <v-btn color="success" icon><v-icon>mdi-printer</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="cancel" color="warning">
                            avbryt
                        </v-btn>
                        <div class="mx-1"></div>
                        <v-btn @click="save" :disabled="!canSave()" color="success">
                            <v-icon left>mdi-content-save</v-icon>
                            lagre
                        </v-btn>
                    </div>
                </v-col>

                <v-col cols="8">
                    <div v-if="currentStatus && currentStatus.type === applicationStatus().INPROGRESS">
                        <!-- <div class="body-1">
                            Under behandling:
                        </div>
                        <v-textarea filled></v-textarea> -->
                    </div>
                    <div v-if="currentStatus && currentStatus.type === applicationStatus().NEEDINFO">
                        <v-textarea v-model="reason" rows="1" label="Legg til tilleggsmelding" filled></v-textarea>
                    </div>
                    <div v-if="currentStatus && currentStatus.type === applicationStatus().REJECTED">
                        <v-textarea v-model="reason" rows="1" label="Legg til tilleggsmelding" filled></v-textarea>
                    </div>
                    <div v-if="currentStatus && currentStatus.type === applicationStatus().GRANTED">
                        <v-textarea v-model="reason" rows="1" label="Legg til tilleggsmelding" filled></v-textarea>

                        <v-radio-group v-model="application.advance" label="Type utbetaling" mandatory>
                            <v-radio label="forskuddsvis" :value="true"></v-radio>
                            <v-radio label="etterskuddsvis" :value="false"></v-radio>
                        </v-radio-group>

                        <!-- <div>{{this.application.foundationFunding}} av totalt {{this.totalProcurementCost}}</div> -->

                        <v-text-field ref="grant" v-model="application.grant" label="Innvilget beløp" filled dense :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]">
                            <template v-slot:append>
                                <div class="py-1">av totalt {{totalProcurementCost}}</div>
                            </template>
                            <template v-slot:append-outer class="ma-auto">
                                <v-btn icon color="primary" @click="application.grant = originalGrant">
                                    <v-icon>mdi-undo</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>

                    </div>
                    <div v-if="currentStatus && currentStatus.type === applicationStatus().DONE">
                        <!-- <div class="body-1">
                            Ferdig:
                        </div>
                        <v-textarea filled></v-textarea> -->
                    </div>

                    <!-- <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Søknad oversikt
                            </v-expansion-panel-header>
                            <v-expansion-panel-content> -->
                    <application-summary class="pa-0 ma-0" :id="application.id" :expanded="true"></application-summary>
                    <!-- </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels> -->

                </v-col>
            </v-row>
        </v-card-text>
        <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel" color="warning">
                avbryt
            </v-btn>
            <v-btn @click="save" :disabled="!canSave()" color="success">
                <v-icon left>mdi-content-save</v-icon>
                lagre
            </v-btn>
        </v-card-actions> -->
    </v-card>
</template>

<script>
// import axios from "axios";
import moment from "moment";
import { ApplicationStatus, applicationStatusText, ProcurementType } from "../utilities/enums";
import * as rules from "../utilities/rules";

export default {
    props: ["applicationId"],
    data() {
        return {
            application: undefined,
            originalGrant: undefined,
            originalStatus: undefined,
            currentStatus: null,
            reason: undefined,

            statuses: [],
            rules,
        };
    },
    computed: {
        // statuses: function() {
        //     let _statuses = [];
        //     for (const key in ApplicationStatus) {
        //         if (Object.prototype.hasOwnProperty.call(ApplicationStatus, key)) {
        //             const status = ApplicationStatus[key];
        //             _statuses.push({ type: status, name: applicationStatusText(status) });
        //         }
        //     }
        //     return _statuses;
        // },
        totalProcurementCost: function() {
            let totalProcurementCost = 0;
            this.application.procurements.forEach(procurement => {
                switch (procurement.type) {
                    case ProcurementType.COST: {
                        totalProcurementCost += procurement.cost;
                        break;
                    }
                    case ProcurementType.HOUR: {
                        totalProcurementCost += procurement.hours * this.application.hourlyRate;
                        break;
                    }
                    default:
                        throw new Error("Unknown procurement type.");
                }
            });
            return totalProcurementCost;
        }
    },
    methods: {
        cancel() {
            this.application.grant = this.originalGrant;
            this.$emit("canceled");
        },
        canSave() {
            if (!this.application || !this.application.statuses || this.application.statuses.length == 0 || !this.currentStatus) {
                return false;
            }

            if (this.currentStatus.type == ApplicationStatus.GRANTED && this.$refs.grant && !this.$refs.grant?.valid) {
                return false;
            }

            return this.originalStatus.type !== this.currentStatus.type;
        },
        async save() {
            if (!this.canSave) {
                return;
            }

            if (this.currentStatus.type == ApplicationStatus.GRANTED && this.$refs.grant && !this.$refs.grant.validate()) {
                // console.log(this.$refs.grant);
                return;
            }

            let status = {
                type: this.currentStatus.type,
                application_id: this.application.id,
                createdAt: moment().unix(),
                createdBy_id: this.$store.getters.user.id
            };

            if (this.currentStatus.type == ApplicationStatus.GRANTED) {
                await this.$store.dispatch("updateApplication", this.application);
            }

            await this.$store.dispatch("updateApplicationStatus", { status, applicationId: this.application.id, reason: this.reason });

            this.$emit("saved");
        }
    },
    created() {
        this.application = { id: this.applicationId };
    },
    async beforeMount() {
        for (const key in ApplicationStatus) {
            if (Object.prototype.hasOwnProperty.call(ApplicationStatus, key)) {
                const status = ApplicationStatus[key];
                this.statuses.push({ type: status, name: applicationStatusText(status) });
            }
        }
    },
    async mounted() {
        this.application = await this.$store.dispatch("getApplication", { applicationId: this.applicationId });
        this.application.advance == 0 ? (this.application.advance = false) : (this.application.advance = true);

        this.originalGrant = this.application.grant;

        this.$nextTick(() => {
            let status = this.application.statuses[this.application.statuses.length - 1];
            if (status) {
                let _status = this.statuses.find(s => s.type === status.type);
                this.$set(this, "currentStatus", _status);

                this.$set(this, "originalStatus", _status);
            }
        });
    }
};
</script>

<style lang="scss">
.v-text-field {
    .v-input__append-outer {
        margin: 8px !important;
    }
}
</style>